import {
  INIT_BUYCART,
  ADD_CART,
  GET_USERINFO,
  RECORD_USERINFO,
  ADD_ANIMATION,
  SHOW_CART,
  REDUCE_CART,
  EDIT_CART,
  CLEAN_CART,
  INIT_SHOPPARAM
} from './mutation-types'
import router from '../router'
import {saveCart, getCart, getShopParam} from '../api/index'
import {getLocalStorage, setLocalStorage, removeLocalStorage} from '../utils/storage'
import {Message} from 'element-ui'

const handleInvalidCartSession = (state) => {
  removeLocalStorage('UserUUID')
  removeLocalStorage('Token')
  removeLocalStorage('UserInfo')
  removeLocalStorage('LoginUUID')
  state.userInfo = null
  state.login = false
  state.cartList = []
  Message.error({message: '登录信息失效，请重新登录'})
  router.replace({path: '/login'})
}

export default {
  // 网页初始化时获取商城信息
  [INIT_SHOPPARAM] (state) {
    if (getLocalStorage('ShopParam')) {
      state.shopParam = JSON.parse(getLocalStorage('ShopParam'))
    }
    getShopParam().then(res => {
      if (res.status > 0) {
        state.shopParam = res.data
        setLocalStorage('ShopParam', JSON.stringify(res.data))
      } else {
        Message.error({message: '商城设置获取失败'})
      }
    })
  },
  // 网页初始化时从本地缓存获取购物车数据
  [INIT_BUYCART] (state) {
    if (getLocalStorage('UserUUID')) {
      // 登录
      getCart(getLocalStorage('UserUUID')).then(res => {
        if (res.status > 0 && res.data === false) {
          handleInvalidCartSession(state)
          return
        }
        if (res.status > 0) {
          let sCart = []
          res.data.forEach(obj => {
            let good = {
              checked: obj.Chk ? '1' : '0',
              cpBH: obj.CpBH,
              goodsId: obj.GoodsUUID,
              productId: obj.SkuUUID,
              productImg: obj.MainImg,
              productName: obj.SkuFullName,
              productNum: obj.Nd,
              salePrice: obj.DjXs,
              Nmoq: obj.Nmoq,
              Nstep: obj.Nstep
            }
            sCart.push(good)
          })
          // setLocalStorage('buyCart', sCart)
          state.cartList = sCart
        } else {
          // fail
        }
      })
    } else {
      // 未登录
      // let initCart = getLocalStorage('buyCart')
      // if (initCart) {
      //   state.cartList = JSON.parse(initCart)
      // }
    }
  },
  // 清空购物车
  [CLEAN_CART] (state) {
    // setLocalStorage('buyCart', [])
    state.cartList = []
  },
  // 加入购物车
  [ADD_CART] (state, {goodsId, productId, cpBH, salePrice, productName, productImg, productNum = 1, minNum = 1, stepNum = 1}) {
    if (getLocalStorage('UserUUID')) {
      getCart(getLocalStorage('UserUUID')).then(res => {
        if (res.status > 0 && res.data === false) {
          handleInvalidCartSession(state)
          return
        }
        if (res.status > 0) {
          let remoteCart = []
          res.data.forEach(obj => {
            let good = {
              checked: obj.Chk ? '1' : '0',
              cpBH: obj.CpBH,
              goodsId: obj.GoodsUUID,
              productId: obj.SkuUUID,
              productImg: obj.MainImg,
              productName: obj.SkuFullName,
              productNum: obj.Nd,
              salePrice: obj.DjXs,
              Nmoq: obj.Nmoq,
              Nstep: obj.Nstep
            }
            remoteCart.push(good)
          })
          // setLocalStorage('buyCart', remoteCart)
          state.cartList = remoteCart
          let cart = state.cartList // 购物车
          let falg = true
          let Nmoq = minNum
          let Nstep = stepNum
          let goods = {
            cpBH,
            goodsId,
            productId,
            salePrice,
            productName,
            productImg,
            Nmoq,
            Nstep
          }
          if (cart.length) { // 有内容
            cart.forEach(item => {
              if (item.productId === productId) {
                if (item.productNum >= 0) {
                  falg = false
                  if (item.productNum < minNum) {
                    item.productNum = minNum
                  } else {
                    item.productNum += productNum
                  }
                }
              }
            })
          }
          if (!cart.length || falg) {
            if (productNum < minNum) {
              goods.productNum = minNum
            } else {
              goods.productNum = productNum
            }
            goods.checked = '1'
            cart.push(goods)
          }
          state.cartList = cart
          let cartRemote = []
          cart.forEach((obj, i) => {
            let good = {
              Chk: 1,
              SkuUUID: obj.productId,
              Nd: obj.productNum,
              OrderIndex: i
            }
            cartRemote.push(good)
          })
          let sCart = {
            UserUUID: getLocalStorage('UserUUID'),
            Skus: cartRemote
          }
          saveCart(sCart).then(res => {
            // Remove the conditional structure
            // success
          })
          // 存入localStorage
          // setLocalStorage('buyCart', cart)
        } else {
          // fail
        }
      })
    }
  },
  // 加入购物车动画
  [ADD_ANIMATION] (state, {moveShow, elLeft, elTop, img, cartPositionT, cartPositionL, receiveInCart}) {
    state.showMoveImg = moveShow
    if (elLeft) {
      state.elLeft = elLeft
      state.elTop = elTop
    }
    state.moveImgUrl = img
    state.receiveInCart = receiveInCart
    if (cartPositionT) {
      state.cartPositionT = cartPositionT
      state.cartPositionL = cartPositionL
    }
  },
  // 是否显示购物车
  [SHOW_CART] (state, {showCart}) {
    // let timer = null
    state.showCart = showCart
    // clearTimeout(timer)
    // if (showCart) {
    //   timer = setTimeout(() => {
    //     state.showCart = false
    //   }, 5000)
    // }
  },
  // 移除商品
  [REDUCE_CART] (state, {productId}) {
    let cart = state.cartList
    cart.forEach((item, i) => {
      if (item.productId === productId) {
        cart.splice(i, 1)
      }
    })
    state.cartList = cart
    if (getLocalStorage('UserUUID')) {
      let cartRemote = []
      cart.forEach((obj, i) => {
        let good = {
          Chk: parseInt(obj.checked),
          SkuUUID: obj.productId,
          Nd: obj.productNum,
          OrderIndex: i
        }
        cartRemote.push(good)
      })
      let sCart = {
        UserUUID: getLocalStorage('UserUUID'),
        Skus: cartRemote
      }
      saveCart(sCart).then(res => {
        // Remove the conditional structure
        // success
      })
    }
    // 存入localStorage
    // setLocalStorage('buyCart', state.cartList)
  },
  // 修改购物车
  [EDIT_CART] (state, {productId, productNum, checked}) {
    let cart = state.cartList
    if (productNum) {
      cart.forEach((item, i) => {
        if (item.productId === productId) {
          item.productNum = productNum
          item.checked = checked
        }
      })
    } else if (productId) {
      cart.forEach((item, i) => {
        if (item.productId === productId) {
          cart.splice(i, 1)
        }
      })
    } else {
      cart.forEach((item) => {
        item.checked = checked ? '1' : '0'
      })
    }
    state.cartList = cart
    if (getLocalStorage('UserUUID')) {
      let cartRemote = []
      cart.forEach((obj, i) => {
        let good = {
          Chk: parseInt(obj.checked),
          SkuUUID: obj.productId,
          Nd: obj.productNum,
          OrderIndex: i
        }
        cartRemote.push(good)
      })
      let sCart = {
        UserUUID: getLocalStorage('UserUUID'),
        Skus: cartRemote
      }
      saveCart(sCart).then(res => {
        // Remove the conditional structure
        // success
      })
    }
    // 存入localStorage
    // setLocalStorage('buyCart', state.cartList)
  },
  // 记录用户信息
  [RECORD_USERINFO] (state, info) {
    if (typeof info === 'string') {
      info = JSON.parse(info)
    }
    state.userInfo = info
    state.login = true
    let k = Object.keys(state.userInfo.info)
    k.forEach((obj) => {
      setLocalStorage(obj, state.userInfo.info[obj])
    })
    setLocalStorage('UserInfo', info)
  },
  // 获取用户信息
  [GET_USERINFO] (state, info) {
    if (state.userInfo && (state.userInfo.username !== info.username)) {
      return
    }
    if (!state.login) {
      return
    }
    if (!info.message) {
      state.userInfo = {...info}
    } else {
      state.userInfo = null
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js